import axios from 'axios';
import { CMIC_FIELD_REST__NAMES } from '../../../shared/Constants';
import { handleLoginUserViaAuth2 } from '../../../shared/UtilityFunctions';

export const fetchAttachments = async (id, BASE_URL, userInfo) => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${BASE_URL}/${id}/child/RelatedDocumentView?offset=0&limit=500&totalResults=false&expand=DocRevisionView,DocumentsView&onlyData=true`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);

		return result.data;
	} catch (error) {
		console.log('fetchAttachments() Error:', error);
		return {
			count: 0,
		};
	}
};

export const fetchDocRevisions = async (id, BASE_URL, userInfo) => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${BASE_URL}/${id}/child/DocRevisionView?offset=0&limit=500&onlyData=true`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);
		return result.data;
	} catch (error) {
		console.log('fetchAttachments() Error:', error);
		return {
			count: 0,
		};
	}
};

export const fetchRFIStatus = async userInfo => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.rfistatus}?offset=0&limit=100&totalResults=false&orderBy=PmrfisStatusName&onlyData=true`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);

		return (result.data.items || []).map(item => ({
			label: item.PmrfisStatusName,
			value: item.PmrfisStatusCode,
		}));
	} catch (error) {
		console.log('fetchRFIStatus() ERROR', error);
		return [];
	}
};

export const fetchIssueStatus = async userInfo => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.issuestatus}?offset=0&limit=100&totalResults=false&onlyData=true`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);

		return result.data.items || [];
	} catch (error) {
		console.log('fetchIssueStatus() ERROR', error);
		return [];
	}
};

export const fetchIssueSeverity = async userInfo => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.issuepriority}?offset=0&limit=100&totalResults=false&onlyData=true`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);

		return result.data.items || [];
	} catch (error) {
		console.log('fetchIssueSeverity() ERROR', error);
		return [];
	}
};

export const fetchIssueType = async userInfo => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.issuetype}?offset=0&limit=100&totalResults=false&onlyData=true`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);

		return result.data.items || [];
	} catch (error) {
		console.log('fetchIssueType() ERROR', error);
		return [];
	}
};

export const fetchIssueLocationcode = async (userInfo, projId) => {
	const URL = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.locationcode}?offset=0&limit=25&orderBy=PmdlCode&onlyData=true&finder=searchbyname;projOraseq=${projId}`;
	// const URL = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.locationcode}?offset=0&limit=25&orderBy=PmdlCode&onlyData=true&finder=selectbyprojectuuid;projectUuid=${projId}`;
	try {
		const result = await axios.get(URL, {
			...handleLoginUserViaAuth2(userInfo),
		});
		return (result.data.items || []).map(item => ({
			label: item.PmdlCode,
			value: item.PmdlCode,
		}));
	} catch (error) {
		console.log('fetchIssueLocationcode() ERROR', error);
		return [];
	}
};
export const fetchDJPreparedBy = async (userInfo, projId) => {
	try {
		const result = await axios.get(
			`${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.contacts}?offset=0&limit=1000&totalResults=false&orderBy=PmpcFirstName,PmpcLastName&onlyData=true&finder=searchbyname;projOraseq=${projId}`,
			{
				...handleLoginUserViaAuth2(userInfo),
			},
		);

		return (result.data.items || []).map(item => ({
			label: `${item.PmpcFirstName} ${item.PmpcLastName}`,
			value: `${item.PmpcContactCode}~${item.PmpcPartnCode}~${item.PmpcPartnTypeCode}`,
		}));
	} catch (error) {
		console.log('fetchDJPreparedBy() ERROR', error);
		return [];
	}
};

export const fetchDJRainyDay = () => {
	return [
		{
			label: 'Y',
			value: 'Y',
		},
		{
			label: 'N',
			value: 'N',
		},
	];
};

export const fetchDJStatus = () => {
	return [
		{
			label: 'Pending',
			value: 'Pending',
		},
		{
			label: 'Submitted',
			value: 'Submitted',
		},
	];
};
